

// Actions for dispatching
export function decrementBadge() {
    return (dispatch) => {
        if(window.device && window.device.platform.toLowerCase() === 'ios'){
            if(window.cordova && window.cordova.plugins.notification) {
                window.cordova.plugins.notification.badge.clear();
            }
        }
        else {
            if(window.cordova && window.cordova.plugins.notification && window.cordova.plugins.notification.local){
                window.cordova.plugins.notification.local.hasPermission(
                    (v)=>{
                        if(v === true){
                            window.cordova.plugins.notification.local.clearAll();
                        }
                })
            }
            //going to keep this badge clear method in here just on the off chance
            //some android phones are still using compatible launchers
            if(window.cordova && window.cordova.plugins.notification) {
                window.cordova.plugins.notification.badge.clear();
            }
        }
    }
}

export function incrementBadge() {
    return (dispatch) => {
        // if(window.cordova && window.cordova.plugins.notification) {
        //     window.cordova.plugins.notification.badge.increase(1, function (badge) {
        //         
        //     });
        // }
    }
}




// WEBPACK FOOTER //
// ./src/actions/cordovaActions.js